import { FC } from "react";
import { TablePagination } from "@mui/material";
import { useCollectionsContext } from "../hooks/useCollectionsContext";
import { ROWS_PER_PAGE_OPTIONS } from "../constants";

export const CollectionsTablePagination: FC = () => {
  const { pagination, page, rowsPerPage, changePage, changeRowsPerPage } =
    useCollectionsContext();

  return (
    <TablePagination
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      component="div"
      count={pagination?.total || 0}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={changePage}
      onRowsPerPageChange={changeRowsPerPage}
    />
  );
};
